import { isRecoveryPath } from "@/lib/posthog-suppressed-path";

// Capability exists only in this document's memory, never DOM, cookies or browser storage.
let pendingToken: string | null = null;
export function captureRecoveryFragment(): void {
	if (typeof window === "undefined") return;
	if (!isRecoveryPath(window.location.pathname)) {
		pendingToken = null;
		return;
	}
	if (!window.location.hash) return;
	const fragment = window.location.hash;
	// Scrub before parsing, scheduling effects, loading analytics, or making any request.
	window.history.replaceState(window.history.state, "", window.location.pathname + window.location.search);
	pendingToken = null;
	const params = new URLSearchParams(fragment.slice(1));
	const values = params.getAll("recovery");
	const value = values[0];
	if (
		values.length === 1 &&
		value &&
		value.length <= 2048 &&
		/^r1\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/.test(value)
	)
		pendingToken = value;
}
export function takeRecoveryToken(): string | null {
	const value = pendingToken;
	pendingToken = null;
	return value;
}
